// src/pages/StudentsPage.tsx
import React, { useState } from 'react';
import StudentCard from '../components/StudentCard';
import { students } from '../data/students';
import StudentModal from '../components/StudentModal';

interface Student {
  id: number;
  name: string;
  favoriteQuote: string;
  favoriteSong: string;
  photo: string;
  githubLink?: string; // Campos opcionais para links
  linkedinLink?: string; // Campos opcionais para links
}

// CSS para o grid de alunos
const gridStyles = `
  .students-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  
  @media (max-width: 1024px) {
    .students-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 640px) {
    .students-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const StudentsPage: React.FC = () => {
    const [selectedStudent, setSelectedStudent] = useState<Student | null>(null);

    const openModal = (student: Student) => {
        setSelectedStudent(student);
    };

    const closeModal = () => {
        setSelectedStudent(null);
    };

    return (
        <>
            <style>{gridStyles}</style>
            <main 
                id="main-content"
                className="students-page min-h-screen bg-black text-white flex flex-col items-center py-8 px-4 md:py-12"
            >
                <h1 className="text-3xl md:text-5xl font-bold text-gold mb-3 md:mb-4 text-center">Alunos</h1>
                <p className="text-white/60 text-base md:text-lg mb-8 md:mb-12 text-center max-w-3xl px-2">
                    Conheça os alunos que fazem parte do Anuário AMS 2025 — suas frases favoritas e músicas que os inspiram.
                </p>
                
                {/* Grid: 3 colunas desktop, 2 tablet, 1 mobile */}
                <div className="students-grid">
                    {students.map((student) => (
                        <StudentCard 
                            key={student.id} 
                            student={student} 
                            onClick={() => openModal(student)} 
                        />
                    ))}
                </div>
            </main>

            <StudentModal student={selectedStudent} onClose={closeModal} />
        </>
    );
};

export default StudentsPage;